// config.js
const config = {
 //  baseUrl: "http://192.168.31.166:8090/api",
  baseUrl: "/api",
  upload: {
    file: "/file/upload",
    editor: "/file/editor/upload",
  },
  webSocket:{
   //  baseUrl:"ws://192.168.31.166:8090/api/websocket",
    baseUrl:"/api/websocket",
  },
  alipay: {
    returnUrl: "http://192.168.31.166:8080/home/myOrder",
    natappUrl: "http://9qzsm2.natappfree.cc",
  }
};

module.exports = config;